import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_donvitinh, Lists_nhomvattuhanghoa } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-hanghoaedit',
  templateUrl: './hanghoaedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./hanghoaedit.component.scss'],
    providers: [ListService, Repository]
})


export class hanghoaeditComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    
    inputparents: any
    inputnhomvattus: any
    inputdvts: any
    indLoading: boolean = false;    
    doituongSelect: any = { Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:null,Nhom_Doi_Tuong_ID:null,Don_Vi_Id:null,Ma_Ao:null,
      Ten_Khac: null, Chat_Lieu: null, Don_Vi_Tinh_Id: null, Thue_Suat: null, Gia_Nhap: null, Gia_Ban_Le: null, Gia_Ban_Buon: null
      , Nhom_Vat_Tu_Id:null};    
    nhomdtid: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

    nhom_vattu: boolean = false;
    @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
    @ViewChild('slDonViTinh', { static: false }) slDonViTinh: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        let data = JSON.parse(authlogin);
        var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
        // nhóm vật tư
        if (nhomdoituongid.toLowerCase() == ("FE2C6389-6483-40E4-BEEB-D699D9164D88").toLowerCase())
          this.nhom_vattu = true;

      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
      this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/' + id +'/'+donviid)
        .subscribe(response => {            
            this.inputparents=response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_nhomvattuhanghoa.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputnhomvattus = response;
        });
      this.repo.getRequest("api/doituong/getall2/" + Lists_donvitinh.id + '/null/' + donviid)
        .subscribe(response => {
          this.inputdvts = response;
        });
      

      this.doituongSelect = {
        Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null, Ghi_Chu: null, Parent: null, Trang_Thai: null, Nhom_Doi_Tuong_ID: nhomdoituongid, Don_Vi_Id: donviid, Ma_Ao: null,
        Ten_Khac: null, Chat_Lieu: null, Don_Vi_Tinh_Id: null, Thue_Suat: null, Gia_Nhap: null, Gia_Ban_Le: null, Gia_Ban_Buon: null
        , Nhom_Vat_Tu_Id:null
      };    
        
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
        }
        else {
            console.log(id);
          this.repo.getRequest("api/doituonghang/getbyid/" + id)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id = id;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;

              this.doituongSelect.Ten_Khac = response.Ten_Khac;
              this.doituongSelect.Chat_Lieu = response.Chat_Lieu;
              this.doituongSelect.Don_Vi_Tinh_Id = response.Don_Vi_Tinh_Id;
              this.doituongSelect.Thue_Suat = response.Thue_Suat;
              this.doituongSelect.Gia_Nhap = response.Gia_Nhap;
              this.doituongSelect.Gia_Ban_Le = response.Gia_Ban_Le;
              this.doituongSelect.Gia_Ban_Buon = response.Gia_Ban_Buon;
              this.doituongSelect.Nhom_Vat_Tu_Id = response.Nhom_Vat_Tu_Id;
              
            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
          this.slDonViTinh.focus();
            event.preventDefault();
          }
  }
  keyDvtPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên vật tư, hàng hóa!.', 'error');
            return;
        }
      this.repo.postRequest("api/doituonghang/addorupdate",this.doituongSelect)
            .subscribe(response => {  
                console.log(response);
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
    
   

   


}
